import { render, staticRenderFns } from "./ReasonsToChoose.vue?vue&type=template&id=2f96e8a4&scoped=true"
import script from "./ReasonsToChoose.vue?vue&type=script&lang=js"
export * from "./ReasonsToChoose.vue?vue&type=script&lang=js"
import style0 from "./ReasonsToChoose.vue?vue&type=style&index=0&id=2f96e8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96e8a4",
  null
  
)

export default component.exports